import React from "react";
import Page from "../../components/Page";

import CreateShiftTypeForm from "../../components/forms/CreateShiftTypeForm";
import CenteredPageContentContainer from "../../components/CenteredPageContentContainer";
import PaperContainer from "../../components/PaperContainer";

const CreateShiftTypePage = () => (
  <Page enableGoBack title="Dienstsoort toevoegen">
    <CenteredPageContentContainer>
      <PaperContainer title="Dienstsoort toevoegen">
        <CreateShiftTypeForm />
      </PaperContainer>
    </CenteredPageContentContainer>
  </Page>
);

export default CreateShiftTypePage;



// WEBPACK FOOTER //
// ./src/pages/ShiftType/CreateShiftTypePage.js